import { useEffect, useState } from "react";
import { apiClient } from "@/App";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ClipboardList } from "lucide-react";
import { HistoryEntry } from "@/components/calendar/RideActions";
import { fmtStamp, fmtTime } from "@/lib/calendar";

export const ChangeLogCard = ({ refreshKey = 0, onOpenRide }) => {
  const [log, setLog] = useState([]);
  const [cancelled, setCancelled] = useState([]);

  useEffect(() => {
    apiClient.get("/dispatch/change-log", { params: { limit: 100 } }).then(({ data }) => setLog(data)).catch(() => {});
    apiClient.get("/dispatch/cancelled-rides").then(({ data }) => setCancelled(data)).catch(() => {});
  }, [refreshKey]);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="change-log-card">
      <h3 className="font-heading font-bold text-lg flex items-center gap-2 mb-3"><ClipboardList className="w-5 h-5 text-cyan-600" />Change Record</h3>
      <Tabs defaultValue="changes">
        <TabsList>
          <TabsTrigger value="changes" data-testid="change-log-tab">All Changes ({log.length})</TabsTrigger>
          <TabsTrigger value="cancelled" data-testid="cancelled-tab">Cancelled Rides ({cancelled.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="changes" className="pt-3 space-y-2 max-h-96 overflow-y-auto" data-testid="change-log-list">
          {log.length === 0 && <p className="text-sm text-slate-500">No changes recorded yet.</p>}
          {log.map((h) => (
            <button key={h.id} type="button" className="block w-full text-left hover:bg-slate-50 rounded-lg transition-colors duration-150" onClick={() => onOpenRide(h.ride_id)}>
              <HistoryEntry h={h} showClient />
            </button>
          ))}
        </TabsContent>
        <TabsContent value="cancelled" className="pt-3 space-y-2 max-h-96 overflow-y-auto" data-testid="cancelled-list">
          {cancelled.length === 0 && <p className="text-sm text-slate-500">No cancelled rides.</p>}
          {cancelled.map((r) => (
            <button key={r.id} type="button" onClick={() => onOpenRide(r.id)}
              className="w-full text-left rounded-xl border border-red-200 bg-red-50 p-3 hover:bg-red-100 transition-colors duration-150" data-testid={`cancelled-ride-${r.id}`}>
              <p className="font-semibold text-sm">{r.client_name} · {r.pickup_date} {fmtTime(r.pickup_time)}</p>
              <p className="text-xs text-red-700">Cancelled {r.cancelled_at ? fmtStamp(r.cancelled_at) : ""} by {r.cancelled_by || "dispatch"}{r.cancel_reason ? ` — ${r.cancel_reason}` : ""}</p>
            </button>
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ChangeLogCard;
